var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['weekend-switch-wrapper']] = true, _obj[_vm.$style['active']] = !_vm.value, _obj ),on:{"click":function($event){_vm.model = !_vm.value}}},[_c('Icon',{attrs:{"name":"calendar"}}),_c('p',{class:_vm.$style['weekends']},[_vm._v(_vm._s(_vm.$t("weekends"))+": "+_vm._s(_vm.$t(_vm.status)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }